import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";

export default function VendorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const vendorId =location?.state?.vendorId;
  // Button route config
  const tabs = [
    { label: "Vendor List", path: `/vendor` },
    { label: `${vendorId ? 'Edit Vendor' : 'Add Vendor'}`, path: `/vendor/new-vendor` },
  ];

  return (
    <section className='p-4'>
      <div className='flex gap-3 items-center py-3 border-b border-gray-400'>
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <Button
              key={tab.path}
              variant="outlined"
              onClick={() => navigate(`${tab.path}`)}
              className={`!capitalize !text-[15px] !font-medium 
                        ${
                          isActive
                            ? "!bg-zinc-700 !text-white !border-none"
                            : "!bg-gray-200 !text-primary !border-zinc-400 "
                        }
                      `}
            >
              {tab.label}
            </Button>
          );
        })}
      </div>
      <div className="mt-4 bg-white p-4 shadow-md rounded-[4px]">
        <Outlet />
      </div>
    </section>
  );
}
